export const FETCH_START = 'sigevents/FETCH_START'
export const FETCH_SUCCESS = 'sigevents/FETCH_SUCCESS'
export const FETCH_FAILURE = 'sigevents/FETCH_FAILURE'

export const FETCH_INCIDENTS_START = 'sigevents/incidents/FETCH_START'
export const FETCH_INCIDENTS_SUCCESS = 'sigevents/incidents/FETCH_SUCCESS'
export const FETCH_INCIDENTS_FAILURE = 'sigevents/incidents/FETCH_FAILURE'

export const SHOW_INCIDENT = 'sigevents/incidents/SHOW'
export const HIDE_INCIDENT = 'sigevents/incidents/HIDE'

export const SELECT_EVENTS = 'sigevents/SELECT_EVENTS'
export const NEXT_EVENT = 'sigevents/NEXT_EVENT'
export const PREV_EVENT = 'sigevents/PREV_EVENT'
export const CLEAR_SELECTION = 'sigevents/CLEAR_SELECTION'

export const OPEN_EDITOR = 'sigevents/OPEN_EDITOR'
export const CLOSE_EDITOR = 'sigevents/CLOSE_EDITOR'
export const SET_INCIDENT_ID = 'sigevents/SET_INCIDENT_ID'
export const SET_SUBJECT = 'sigevents/SET_SUBJECT'
export const SET_ADDRESS = 'sigevents/SET_ADDRESS'
export const SET_DESCRIPTION = 'sigevents/SET_DESCRIPTION'
export const SET_POSITION = 'sigevents/SET_POSITION'
export const SET_ERROR = 'sigevents/SET_ERROR'

export const ADD_EVENT = 'sigevents/ADD_EVENT'
export const EDIT_EVENT = 'sigevents/EDIT_EVENT'
